<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_ix"></a>“The greater part of our happiness or misery depends on our dispositions and not our circumstances.”</p>
<p class="center1"><span class="small">MARTHA WASHINGTON</span><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?26135e54